import { Panel, RoutedPanelProps } from '@/components/Layout/Panel/Panel';
import { useStackNavigate } from '@/app/navigation/stack-links';
import { useWork } from '@/features/works/works.hooks';
import { buildTicketUrl } from '@/lib/ticketUrls';
import { useTicket } from './tickets.hooks';
import { useEffect } from 'react';

export function TicketRedirectPanel({
  params,
  path,
  basePath,
  ...panelProps
}: RoutedPanelProps) {
  const { ticketId } = params;
  const go = useStackNavigate();
  const { data: ticket } = useTicket(ticketId, { suspense: false });
  const { data: work } = useWork(ticket?.werk_id, {});

  useEffect(() => {
    if (ticket?.project_id) {
      go({ to: buildTicketUrl(ticket), replace: true });
    }
    if (ticket?.werk_id && work) {
      go({ to: buildTicketUrl(ticket, { work }), replace: true });
    }
  }, [go, ticket, work]);

  return <Panel {...panelProps}>redirecting...</Panel>;
}
